import React, { useContext, useEffect, useState } from "react";
import { getUpcomingReleaseInfo } from "../../../services/releaseData";
import loaderContext from "../../../../../../context/loader/loaderContext";
import { useConfig } from "../../../../../../context/config/configContext";

const UpcomingRelease = () => {
    const [upcomingRelease, setUpcomingRelease] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { updateLoaderStatus } = useContext(loaderContext);
    const { config } = useConfig();

    useEffect(() => {
        const getData = async () => {
            setIsLoading(true);
            updateLoaderStatus(true);
            const response = await getUpcomingReleaseInfo();
            setUpcomingRelease(response);
            setIsLoading(false);
            updateLoaderStatus(false);
        };
        getData();
    }, []);

    //if (!upcomingRelease || upcomingRelease.length === 0) return null;


    return (
        <div className="dashboard-wrapper">
            {(!upcomingRelease || upcomingRelease.length === 0) && !isLoading ? (
                <div className="upcoming-release-no-records">No Upcoming Releases</div>) : (!upcomingRelease || upcomingRelease.length === 0) && isLoading ? (<div></div>) : (
                    <div className="release-container">
                        <div className="upcoming-grid">
                            {upcomingRelease?.map((item) => (
                                <React.Fragment key={item.Id}>
                                    <div className="release-header">
                                        <h3>{item.Title}</h3>
                                        <h4>Version : {item.VersionName}</h4>
                                        <p className="release-date">
                                            Release Date: {item.ReleaseDate}
                                        </p>
                                    </div>
                                    <div className="upcoming-card">

                                        {item.ImageUrl && config.REACT_APP_RELEASE_KEY && (
                                            <img
                                                src={item.ImageUrl + process.env.REACT_APP_RELEASE_KEY}
                                                src={item.ImageUrl + config.REACT_APP_RELEASE_KEY}
                                                alt={item.Title}
                                                className="upcoming-image"
                                            />
                                        )}
                                        <p>{item.Description}</p>
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>

                    </div>
                )}
        </div >
    );
};

export default UpcomingRelease;